import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { Row, Col, Card, Button  } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import ScanPointsList from './ScanPointsList/ScanPointsList';
import SupportModal from '../Modals/SupportModal/SupportModal';
import ScanPointsHelpModal from '../Modals/ScanPointsHelpModal/ScanPointsHelpModal';

ScanPointsContainer.propTypes = {
    eventID: PropTypes.string.isRequired
}

function ScanPointsContainer(props) {   
    const { partnerPortalSettings } = useSelector(state => state.partnerPortalSettings);
    const { isScanPointSalesEnabled } = partnerPortalSettings;
    const { eventID } = props;
    const [ supportModalShow, setSupportModalShow ] = useState(false);
    const [ helpModal, setHelpModal ] = useState(false);
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Row>
                <Col md={8}>
                    <h3>{t('scan_points.scan_points_header')}</h3>
                    <Card>
                        <Card.Header>
                            {t('scan_points.scan_points')}
                            {isScanPointSalesEnabled ?
                                <NavLink to="scanPoints/order" className="btn btn-link btn-sm float-right">{t('scan_points.order_new_scan_point')}</NavLink>
                            : null} 
                        </Card.Header>
                        <ScanPointsList
                            eventID={eventID}
                            limit={25}
                            isScanPointSalesEnabled={isScanPointSalesEnabled}
                        />
                    </Card>
                </Col>
                <Col md={4}>
                    <h3>{t('instructions.help_and_support')}</h3>
                    <Card>
                        <Card.Header>{t('instructions.scan_points.eventos_contact_header')}</Card.Header>
                        <Card.Body>
                            <p>{t('instructions.scan_points.eventos_contact_text')}</p>
                            <p>{t('instructions.scan_points.eventos_contact_phase1')} <a href="https://contact.eventos.fi/" target="_blank" rel="noopener noreferrer">https://contact.eventos.fi/</a></p>
                            <p>{t('instructions.scan_points.eventos_contact_phase2')}</p>

                            <p style={{ marginBottom: '0.5rem' }}>{t('instructions.scan_points.eventos_contact_supported_browsers')}</p>
                            <ul style={{ marginBottom: '0px' }}>
                                <li>Google Chrome</li>
                                <li>Mozzilla Firefox</li>
                                <li>Microsoft Edge</li>
                                <li>Safari</li>
                            </ul>
                        </Card.Body>
                        {/* <ul className="list-group list-group-flush" style={{ background: '#f0f0f0'}}>
                            <li className="list-group-item"><a href="https://apps.apple.com/fi/app/eventos-contact/id1303576731?l=fi" target="_blank" rel="noopener noreferrer">{t('instructions.scan_points.eventos_contact_download_ios')}</a></li>
                            <li className="list-group-item"><a href="https://play.google.com/store/apps/details?id=fi.prospectum.eventoscontact&hl=fi" target="_blank" rel="noopener noreferrer">{t('instructions.scan_points.eventos_contact_download_android')}</a></li>
                        </ul> */}
                    </Card>
                    <Card>
                        <Card.Header>{t('instructions.help')}</Card.Header>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="pl-0"
                                    onClick={() => setHelpModal('faq')}
                                >
                                    {t('instructions.scan_points.faq')}
                                </Button>
                            </li>
                            <li className="list-group-item">
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="pl-0"
                                    onClick={() => setHelpModal('howTo')}
                                >
                                    {t('instructions.scan_points.how_to_read_scans')}
                                </Button>
                            </li>
                        </ul>
                        <Card.Body>
                            <p style={{ fontWeight: '700'}}>{t('instructions.support_header')}</p>
                            <p>{t('instructions.support_text')}</p>
                            <Button
                                type="button"
                                variant="primary"
                                size="sm"
                                onClick={() => setSupportModalShow(true)}
                            >
                                {t('instructions.open_support_form')}
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <SupportModal
                show={supportModalShow}
                onHide={() => setSupportModalShow(false)}
            />

            {helpModal ?
                <ScanPointsHelpModal
                    show={!!helpModal}
                    type={helpModal.toString()}
                    onHide={() => setHelpModal(false)}
                />
            : null}

        </React.Fragment>
    )
}



export default ScanPointsContainer;